import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { appNoticesLoader } from 'components/appNotices/appNotices';
import { AppNoticeAPI } from 'components/appNotices/types';

export function useAppNotices(): {
  isLoading: boolean;
  data: AppNoticeAPI[];
} {
  const [, { language }] = useTranslation();
  const [appNotices, setAppNotices] = React.useState<AppNoticeAPI[]>([]);

  React.useEffect(() => {
    appNoticesLoader.setLocale(language);
    appNoticesLoader.load().then((notices) => {
      setAppNotices(notices || []);
    });
  }, [language]);

  return { isLoading: !appNotices, data: appNotices };
}
